/* Copyright (c) 2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { getHumanReadableLabel } from "~/tools";

export function getEventActionLabel(actionName: string) {
  return getHumanReadableLabel(actionName);
}
